'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import {
  LetsTalkSection,
  TestimonialsSection,
} from 'Components/Sections/_Legacy/Blockchain'
import {
  Benefits,
  Caas,
  Hero,
  Service,
  TechnologyStack,
  WeOffer,
  WhoIs,
  YourCtos,
} from 'Components/Sections/_Legacy/Cto'
import { Column, Row } from 'Components/UI'
import { BlockchainPageData, CtoPageData } from 'Data/types'

type Props = {
  blockchainPageData?: BlockchainPageData
  ctoPageData?: CtoPageData
}

function CTOPage({ blockchainPageData, ctoPageData }: Props) {
  const ctoPage = ctoPageData?.ctoPage
  const headerTestimonials =
    blockchainPageData?.blockchainPage?.headerTestimonials[0]

  const letsTalk = blockchainPageData?.blockchainPage?.headerLetSTalk[0]

  return (
    <PageWrapper secondary>
      <Header />

      <Column alignCenter fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />
      </Column>

      {/* Full-width column mirrors PageWrapper's own flex context so the
          sections lay out exactly as before — it only adds the <main>
          landmark the page lacked. */}
      <Column alignCenter as="main" fullWidth>
        <Hero data={ctoPage} />

        <WhoIs data={ctoPage} />

        <Service data={ctoPage} />

        <Caas data={ctoPage} />

        <Benefits data={ctoPage} />

        <WeOffer data={ctoPage} />

        <YourCtos data={ctoPage} />

        <TechnologyStack data={ctoPage} />

        <TestimonialsSection data={headerTestimonials} />

        <LetsTalkSection data={letsTalk} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default CTOPage
